import { Modal } from "@mui/material"
import React from "react"
import Loading from "../common/Loading"
import "../../assets/css/modal.css"
import "../modals/scss/fw-modal.scss"

const FWModal = ({
  open,
  handleClose,
  withIcon = false,
  icon = null,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  handleConfirm,
  isLoading,
  children
}) => {
  const handleMainClose = () => {
    handleClose()
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="confirm-modal fw-modal">
        {isLoading ? (
            <Loading />
        ) : (
            <div className="confirm-modal-wrapper">
              {withIcon && (
                  <div className="confirm-modal-icon-wrapper" style={{background: "#ebf0fe"}}>
                    {icon}
                  </div>
              )}

              {children}

              <div className="confirm-modal-btn-wrapper">
                <button className="confirm-modal-btn cancel" onClick={handleMainClose}>
                  {cancelButtonText}
                </button>
                <button className="confirm-modal-btn recalculate" onClick={handleConfirm}>
                  {confirmButtonText}
                </button>
              </div>
            </div>
        )}
      </div>
    </Modal>
  )
}

export default FWModal
